import React from "react";
import AddressForm from "../../forms/account/AddressForm";
import EditCustomerContainer from "../../containers/customers/EditCustomerContainer";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Edit = ({ handleClose, open, address }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("register.title_edit_address")}
    >
      {address ? (
        <EditCustomerContainer customer={address}>
          {({ onSubmit, customer }) => (
            <AddressForm onSubmit={onSubmit} initialValues={customer.profile} />
          )}
        </EditCustomerContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
